import type { PImage } from '../../engine/aliases'
import type { IEntity } from '../../entities/entitiesUtils'
import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import { createId } from '../../main/common'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'

export interface IVoyageProgressBar extends IEntity {
  imageBack: PImage
  image: PImage
}

const objs: IVoyageProgressBar[] = []
export function getAll() {
  return objs
}

export function create(): IVoyageProgressBar {
  // underPerf.recordCreate('need-bars')
  let id = createId()

  let imageBack = spritesUtil.createImage(
    voyageLayers.getLayers().uiOnCam,
    sprites.voyProgress2[0],
  )

  let image = spritesUtil.createImage(
    voyageLayers.getLayers().uiOnCam,
    sprites.voyProgress1[0],
  )

  let obj: IVoyageProgressBar = {
    eType: 'voy-misc',
    id,
    idLoaded: 0,
    isDead: false,
    image,
    imageBack,
  }
  objs.push(obj)
  return obj
}

export function moveTo(obj: IVoyageProgressBar, x: number, y: number) {
  obj.imageBack.x = x
  obj.imageBack.y = y
  obj.image.x = x
  obj.image.y = y
}

export function setValue(obj: IVoyageProgressBar, val: number) {
  if (val < 0) {
    val = 0
  }
  if (val > 1) {
    val = 1
  }
  // if (val < 0.33) {
  //   spritesUtil.setPackedFrame(obj.image, sprites.underNeedBar[1])
  // } else if (val < 0.66) {
  //   spritesUtil.setPackedFrame(obj.image, sprites.underNeedBar[2])
  // } else {
  //   spritesUtil.setPackedFrame(obj.image, sprites.underNeedBar[3])
  // }

  obj.image.visible = val > 0
  obj.imageBack.visible = obj.image.visible

  obj.image.scaleX = val * obj.imageBack.scaleX
  obj.image.x =
    obj.imageBack.x -
    (obj.imageBack.width / 2) * (obj.imageBack.scaleX - obj.image.scaleX)
}

export function updateAll() {
  // l.forEach(objs, (c) => {
  //   update(c)
  // })
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
    c.imageBack.destroy()
  })
}
//export function update(obj: IVoyageProgressBar) {}

export function kill(obj: IVoyageProgressBar) {
  obj.isDead = true
}
